import React, { useState, useEffect } from 'react';
import style from './index.module.css';

type Props = {
    initialTab: string;
    setCurrentTab: (name: string) => void;
    tabs: {
        label: string;
        name: string;
    }[];
};

const Navigation = ({ initialTab, setCurrentTab, tabs }: Props) => {
    // Keep track of active tab internally, and report
    // any changes to it to outer setCurrentTab
    // TODO: get this component interacting with the outer
    // currentTab and setCurrentTab the proper way

    const [activeTab, setActiveTab] = useState<string>(initialTab);

    useEffect(() => {
        setCurrentTab(activeTab);
    }, [activeTab]);

    const tabIsActive = (name: string) => name === activeTab;

    return (
        <ul className={style.menuItems}>
            {tabs.map((tab) => (
                <li key={tab.name} className={`${style.menuItem} ${tabIsActive(tab.name) ? style.selected : ''}`}>
                    <a
                        href="#"
                        className={`${style.menuButton} ${tabIsActive(tab.name) ? style.selected : ''}`}
                        onClick={(event) => {
                            event.preventDefault();
                            if (!tabIsActive(tab.name)) {
                                setActiveTab(tab.name);
                            }
                        }}
                    >
                        {tab.label}
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default Navigation;
